import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, CheckCircle2 } from 'lucide-react';
import { businessInfo } from '../mock';

const BackgroundPreview = () => {
  const backgrounds = [
    {
      id: 1,
      name: "Current Background",
      url: "https://images.unsplash.com/photo-1562259929-b4e1fd3aef09?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxob21lJTIwaW1wcm92ZW1lbnQlMjBjb250cmFjdG9yfGVufDB8fHx8MTc2NTMwNzg2Nnww&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 2,
      name: "Option 1: Roofing Workers",
      url: "https://images.unsplash.com/photo-1625512208347-8b6e3423b174?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxjb250cmFjdG9yJTIwd29ya2luZyUyMG9uJTIwaG91c2UlMjByb29mfGVufDB8fHx8MTc3MDQwODE3M3ww&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 3,
      name: "Option 2: Workers Installing Roof",
      url: "https://images.unsplash.com/photo-1763665814538-8ba04597286c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxjb250cmFjdG9yJTIwd29ya2luZyUyMG9uJTIwaG91c2UlMjByb29mfGVufDB8fHx8MTc3MDQwODE3M3ww&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 4,
      name: "Option 3: Modern Home Exterior",
      url: "https://images.unsplash.com/photo-1762134768304-88c5d735d611?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBob21lJTIwZXh0ZXJpb3IlMjByZW5vdmF0aW9ufGVufDB8fHx8MTc3MDQwODE2Mnww&ixlib=rb-4.1.0&q=85"
    }
  ];

  return (
    <div style={{padding: '40px', background: 'var(--bg-page)'}}>
      <div className="container">
        <h1 className="heading-1" style={{color: 'var(--text-primary)', marginBottom: '40px', textAlign: 'center'}}>
          BACKGROUND OPTIONS PREVIEW
        </h1>
        
        {backgrounds.map((bg) => (
          <div key={bg.id} style={{marginBottom: '60px'}}>
            <h3 className="heading-4" style={{color: 'var(--text-primary)', marginBottom: '20px'}}>
              {bg.name}
            </h3>
            
            <section className="hero-section" style={{minHeight: '600px', position: 'relative'}}>
              <div className="hero-background">
                <img 
                  src={bg.url}
                  alt={bg.name}
                  className="hero-image"
                />
                <div className="hero-overlay"></div>
              </div>

              <div className="container">
                <div className="hero-content">
                  <h1 className="hero-title" style={{color: '#ffffff'}}>
                    SBF HOME IMPROVEMENTS
                  </h1>
                  <h2 className="body-large" style={{color: '#ffffff', marginTop: '20px', fontWeight: '600', fontSize: '1.75rem'}}>
                    Expert Roofing, Siding, Flooring & Repairs – Built to Last
                  </h2>
                  <p className="body-medium" style={{color: '#ffffff', marginTop: '16px', maxWidth: '40ch', lineHeight: '1.6'}}>
                    Professional craftsmanship you can trust. Fully licensed & insured in Pennsylvania.
                  </p>
                  <p className="body-medium" style={{color: '#ffffff', marginTop: '12px', maxWidth: '40ch', lineHeight: '1.6'}}>
                    Protect your home with quality work that stands the test of time.
                  </p>
                  <p className="body-large" style={{color: '#ffffff', marginTop: '20px', fontWeight: '700', fontSize: '1.5rem'}}>
                    Get Your Free Estimate Today
                  </p>
                  
                  <div style={{display: 'flex', gap: '16px', marginTop: '32px', flexWrap: 'wrap'}}>
                    <Link to="/contact" className="btn-primary" style={{fontSize: '1.25rem', padding: '1.25em 2em', fontWeight: '700'}}>
                      GET FREE QUOTE
                    </Link>
                    <a href={`tel:${businessInfo.phone}`} className="btn-secondary">
                      <Phone size={20} style={{marginRight: '8px'}} />
                      CALL NOW
                    </a>
                  </div>
                  <div style={{display: 'flex', alignItems: 'center', gap: '12px', marginTop: '32px'}}>
                    <CheckCircle2 size={20} color="#ffffff" />
                    <span className="caption" style={{color: '#ffffff'}}>PA LICENSE #{businessInfo.license}</span>
                  </div>
                </div>
              </div>
            </section>
          </div>
        ))}

        <div style={{textAlign: 'center', marginTop: '60px'}}>
          <Link to="/" className="btn-primary" style={{fontSize: '1.25rem', padding: '1.25em 2em'}}>
            BACK TO HOME
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BackgroundPreview;